// extracted by mini-css-extract-plugin
export var measureBox = "_a4-0";